import { FileInput, FileInputProps, Input, InputWrapperProps, NumberInputProps, PasswordInput, PasswordInputProps, TextInput, TextInputProps } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { useFormHelperContext } from "../form";
import { useFormState } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";

export interface FieldInputDropzoneProps extends FileInputProps {
    label: string;
    name: string;
    resolver: (file: File | File[]) => string;
    inputWrapper?: InputWrapperProps;
}


export const FieldInputDropzone: React.FC<FieldInputDropzoneProps> = ({ label, inputWrapper, name, resolver, multiple = false, readOnly, ...rest }) => {
    const { register, control, formStore, setValue } = useFormHelperContext();
    const { errors } = useFormState({ control });
    const inputRef = useRef<HTMLInputElement | null>(null);
    const isFocused = useRef(false);
    const [valuePlaceholder, setValuePlaceholder] = useState<number | string>(0);
    if (!register) {
        throw new Error("Field.Dropzone must be used within a FormHelper component");
    }
    if (!resolver) {
        throw new Error("Resolver must be provided");
    }

    useEffect(() => {
        if (isFocused.current && inputRef.current) {
            inputRef.current.focus();
        }
    }, [errors]);

    return (
        <InputWrapper label={label} {...inputWrapper}>
            <div className="flex flex-col w-full">
                
                <FileInput
                    multiple={multiple}
                    leftSectionPointerEvents="none"
                    data-testid={'field-dropzone-' + name}
                    readOnly={readOnly ?? formStore.readOnly}
                    onChange={(event) => {
                        if (event === null) {
                            return;
                        }
                        const value = resolver(event)
                        setValue(name, value);
                    }}
                />
                {typeof errors[name]?.message === 'string' && <Input.Error>{errors[name]?.message}</Input.Error>}
            </div>
        </InputWrapper>
    );
};
